import { useLang } from '../lib/lang';
import { Input } from './ui/input';
import { Label } from './ui/label';
import PhoneInput from './PhoneInput';
import { ShieldCheck } from 'lucide-react';

// Shared identity form used by the express checkout AND the "Rejoindre" modal.
export function ExpressIdentityFields({ form, setForm }) {
  const { t } = useLang();
  return (
    <>
      <div className="grid grid-cols-2 gap-2.5">
        <Field label={t('expFirstName')} value={form.first_name} onChange={(v) => setForm({ ...form, first_name: v })} testid="exp-first-name" />
        <Field label={t('expLastName')} value={form.last_name} onChange={(v) => setForm({ ...form, last_name: v })} testid="exp-last-name" />
      </div>
      <Field label={t('expEmail')} type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="exp-email" />
      <PhoneInput label={t('expPhone')} value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="exp-phone" />
      <Field label={t('expAddress')} value={form.address} onChange={(v) => setForm({ ...form, address: v })} testid="exp-address" />
      <div className="grid grid-cols-3 gap-2.5">
        <Field label={t('expPostcode')} value={form.postcode} onChange={(v) => setForm({ ...form, postcode: v })} testid="exp-postcode" />
        <Field label={t('expCity')} value={form.city} onChange={(v) => setForm({ ...form, city: v })} testid="exp-city" />
        <Field label={t('expCountry')} value={form.country} onChange={(v) => setForm({ ...form, country: v })} testid="exp-country" />
      </div>
      <div className="rounded-xl bg-gold/10 border border-gold/30 px-3 py-2.5 flex items-start gap-2" data-testid="express-secure-banner">
        <ShieldCheck className="w-4 h-4 text-gold-dark shrink-0 mt-0.5" />
        <p className="text-xs text-rolex-green/80 leading-snug">{t('expSecureBanner')}</p>
      </div>
    </>
  );
}

export function Field({ label, value, onChange, type = 'text', testid }) {
  return (
    <div className="space-y-1">
      <Label className="text-xs text-rolex-green/70">{label}</Label>
      <Input type={type} value={value} onChange={(e) => onChange(e.target.value)} className="rounded-xl h-11" data-testid={testid} />
    </div>
  );
}
